(function() {
    if (typeof window.CustomEvent === "function") return false;
    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    window.CustomEvent = CustomEvent;
})();


const $0c9c39612649a272$var$reduce = Function.bind.call(Function.call, Array.prototype.reduce);
const $0c9c39612649a272$var$isEnumerable = Function.bind.call(Function.call, Object.prototype.propertyIsEnumerable);
const $0c9c39612649a272$var$concat = Function.bind.call(Function.call, Array.prototype.concat);
const $0c9c39612649a272$var$keys = Reflect.ownKeys;
if (!Object.values) Object.values = function values(O) {
    return $0c9c39612649a272$var$reduce($0c9c39612649a272$var$keys(O), (v, k)=>$0c9c39612649a272$var$concat(v, typeof k === "string" && $0c9c39612649a272$var$isEnumerable(O, k) ? [
            O[k]
        ] : []), []);
};
if (!Object.entries) Object.entries = function entries(O) {
    return $0c9c39612649a272$var$reduce($0c9c39612649a272$var$keys(O), (e, k)=>$0c9c39612649a272$var$concat(e, typeof k === "string" && $0c9c39612649a272$var$isEnumerable(O, k) ? [
            [
                k,
                O[k]
            ]
        ] : []), []);
};


"use strict";


//# sourceMappingURL=provider-portal.ef952f45.js.map
